import { render } from "./SidebarMobile.vue?vue&type=template&id=8fff2ca0"
import script from "./SidebarMobile.vue?vue&type=script&lang=js"
export * from "./SidebarMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__